import axios from 'axios';
import { apiUrl } from '@/env';
import { IUserProfile, IUserProfileUpdate, IUserProfileCreate } from './interfaces';
import { UploadImageState, OmrTaskState } from '@/store/omr/state';

function authHeaders(token: string) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

axios.interceptors.response.use(
  (response) => {
    // const status = response.status;
    // console.log(status, codeMessage[status]);
    // if (status > 400) {
    //   return Promise.reject(codeMessage[status]);
    // }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);


export const api = {
  async logInGetToken(username: string, password: string) {
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('email', username);
    params.append('password', password);
    return axios.post(`${apiUrl}/api/v1/auth/`, params);
  },
  async createMe(data: IUserProfileCreate) {
    return axios.post(`${apiUrl}/api/v1/user/me/`, data, authHeaders('sign_up'));
  },
  async getMe(token: string) {
    return axios.get<IUserProfile>(`${apiUrl}/api/v1/user/me/`, authHeaders(token));
  },
  async updateMe(token: string, data: IUserProfileUpdate) {
    return axios.put<IUserProfile>(`${apiUrl}/api/v1/user/me/`, data, authHeaders(token));
  },
  async getUsers(token: string) {
    return axios.get<IUserProfile[]>(`${apiUrl}/api/v1/user/`, authHeaders(token));
  },
  async updateUser(token: string, userId: string, data: IUserProfileUpdate) {
    return axios.put(`${apiUrl}/api/v1/user/${userId}`, data, authHeaders(token));
  },
  async createUser(token: string, data: IUserProfileCreate) {
    return axios.post(`${apiUrl}/api/v1/user/`, data, authHeaders(token));
  },
  async passwordRecovery(email: string) {
    return axios.post(`${apiUrl}/api/v1/password-recovery/${email}`);
  },
  async resetPassword(password: string, token: string) {
    return axios.post(`${apiUrl}/api/v1/reset-password/`, {
      new_password: password,
      token,
    });
  },
  // uploadImageList
  async createUploadImageList(token: string, data: UploadImageState) {
    return axios.post<string>(`${apiUrl}/api/v1/upload-image-score/`, data, authHeaders(token));
  },
  async updateOmrTask(token: string, id: string) {
    return axios.put<string>(`${apiUrl}/api/v1/upload-image-score/${id}`, id, authHeaders(token));
  },
  async getOmrTaskList(token: string) {
    return axios.get<OmrTaskState[]>(`${apiUrl}/api/v1/upload-image-score/my-upload/`, authHeaders(token));
  },
  async patchOmrTask(token: string, data: OmrTaskState) {
    return axios.patch(`${apiUrl}/api/v1/upload-image-score/${data.id}`, data, authHeaders(token));
  },
  async getUploadImageScoreList(token: string, id: string) {
    return axios.get<UploadImageState>(`${apiUrl}/api/v1/upload-image-score/${id}`, authHeaders(token));
  },
  // async getDealEvent(token: string, trans_uuid: string) {
  //   if (typeof (EventSource) !== 'undefined') {
  //     return new Promise<MessageEvent>((resolve, reject) => {
  //       const es = new EventSource(`${apiUrl}/api/v1/xml-score/${trans_uuid}`);
  //       es.onmessage = function (event) {
  //         resolve(event);
  //         es.close();
  //       };
  //     });
  //   }
  //   return Promise.reject('抱歉, 您的浏览器不支持 SSE(Server-sent events)');
  // }
  async getDealEvent(token: string, transUUID: string) {
    return axios.get<string>(`${apiUrl}/api/v1/xml-score/event/${transUUID}`, authHeaders(token));
  },
  async getXmlScore(token: string, transUUID: string) {
    return axios.get(`${apiUrl}/api/v1/xml-score/${transUUID}`, authHeaders(token));
  },
};
